export const DEFAULT_LABEL_CONFIRM = 'Confirm'
export const DEFAULT_LABEL_CANCEL = 'Cancel'
